import { UnifiedPeoplePicker } from '@fluentui/react-experiments/lib/UnifiedPeoplePicker';

export function TextFieldEmail({ selectedItems, onItemsRemoved, style, onKeyDown, onBlur }) {
    return (
      <div style={style}>
          <UnifiedPeoplePicker
              selectedItemsListProps={{
                  selectedItems: selectedItems,
                  removeButtonAriaLabel: 'Remove',
                  onItemsRemoved: onItemsRemoved
              }}
              floatingSuggestionProps={{
                  isSuggestionsVisible: false
              }}
              inputProps={{
                  'aria-label': 'Add people',
              }}
              // eslint-disable-next-line react/jsx-no-bind
              onBlur={onBlur} 
              onKeyDown={onKeyDown} 
              // eslint-disable-next-line react/jsx-no-bind
              customClipboardType="recipients"
          />
      </div>
    );
}